{
  "version": 1,
  "asset_id": "bf5daa2b-35b4-4aa9-b20f-69b02fdcc90f",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/bf5daa2b-35b4-4aa9-b20f-69b02fdcc90f/hero-new-480.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/bf5daa2b-35b4-4aa9-b20f-69b02fdcc90f/hero-new-480.avif",
  "original_filename": "hero-new-480.avif",
  "size": 6123,
  "content_type": "image/avif",
  "created_at": "2026-08-02T03:39:00Z"
}
